import { LitElement, html, css } from 'lit';

class ConfirmDialog extends LitElement {
  static get properties() {
    return {
      dialogData: { type: Object },
      onClose: { type: Function },
      isMobile: { type: Boolean, reflect: true }
    };
  }

  static get styles() {
    return css`
      :host {
        display: block;
        width: 100%;
      }

      .dialog {
        width: 100%;
        text-align: center;
        position: relative;
      }

      .dialog h2 {
        margin-top: 0;
        margin-bottom: 16px;
        font-size: 1.25rem;
        color: var(--text-primary-color);
        text-transform: capitalize;
      }

      .dialog p {
        margin-bottom: 24px;
        color: #666;
      }

      .dialog-actions {
        display: flex;
        justify-content: center;
        gap: 16px;
      }

      .dialog-actions button {
        flex: 1;
        padding: 12px;
        border: none;
        border-radius: 20px;
        cursor: pointer;
        font-weight: 500;
        transition: background-color 0.2s, transform 0.1s;
      }

      .dialog-actions button:active {
        transform: scale(0.95);
      }

      .dialog-actions .confirm {
        background-color: var(--base-color);
        color: var( --bg-incoming-message);
      }

      .dialog-actions .cancel {
        background-color: var(--bg-primary-color);
        border: 2px solid var(--base-color);
        color: var(--base-color);
      }

      /* Remove the previous fixed positioning and background */
      :host([isMobile]) {
        /* Optional: Add specific mobile-only styles if needed */
        /* For example: */
        .dialog-actions {
          flex-direction: column;
        }

        .dialog-actions button {
          margin-bottom: 8px;
        }
      }
    `;
  }

  constructor() {
    super();
    this.dialogData = {};
    this.onClose = () => {};
    this.isMobile = false;
  }

  render() {
    return html`
      <div class="dialog">
        <h2>${this.dialogData?.title}</h2>
        ${this.dialogData?.description1 ? html`<p>${this.dialogData?.description1}</p>` : null}
        <p>${this.dialogData?.description}</p>
        <div class="dialog-actions">
          <button class="confirm" @click=${this.dialogData.handleConfirm}>
            ${this.dialogData.yesText || 'Yes'}
          </button>
          <button class="cancel" @click=${this.onClose}>
            ${this.dialogData.noText || 'No'}
          </button>
        </div>
      </div>
    `;
  }
}

customElements.define('confirm-dialog', ConfirmDialog);
export { ConfirmDialog };